import { UserRound, Megaphone, Mail } from "lucide-react";

/**
 * EventOrganizer — displays the organizer, volunteer roles wanted,
 * and a mailto inquiry button when an event has organizer/contact info set.
 */
export default function EventOrganizer({ event }) {
  const organizer = event.organizer;
  const roles = Array.isArray(event.volunteer_roles) ? event.volunteer_roles.filter(Boolean) : [];
  const email = event.contact_email;

  if (!organizer && roles.length === 0 && !email) return null;

  const mailto = email
    ? `mailto:${email}?subject=${encodeURIComponent(`Volunteer Inquiry — ${event.title}`)}`
    : null;

  return (
    <div
      className="mt-8 border border-bdu-gold/15 bg-black/30 p-6 sm:p-7"
      data-testid={`event-organizer-${event.id}`}
    >
      <div className="grid md:grid-cols-2 gap-6">
        {organizer && (
          <div>
            <div className="label-eyebrow flex items-center gap-2" style={{ fontSize: "0.6rem" }}>
              <UserRound size={12} /> Event Organizer
            </div>
            <div className="mt-3 font-serif text-2xl text-bdu-cream">{organizer}</div>
          </div>
        )}

        {roles.length > 0 && (
          <div>
            <div className="label-eyebrow flex items-center gap-2" style={{ fontSize: "0.6rem" }}>
              <Megaphone size={12} /> Volunteers Wanted
            </div>
            <ul className="mt-3 flex flex-wrap gap-2" data-testid={`event-volunteer-roles-${event.id}`}>
              {roles.map((r, i) => (
                <li
                  key={i}
                  className="text-xs uppercase tracking-widest text-bdu-cream/85 border border-bdu-gold/30 px-3 py-1.5"
                  data-testid={`event-volunteer-role-${event.id}-${i}`}
                >
                  {r}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {mailto && (
        <div className="mt-6 pt-6 border-t border-bdu-gold/10 flex flex-wrap items-center gap-4 justify-between">
          <div>
            <div className="text-xs text-bdu-cream/60 leading-relaxed">
              Send inquiries or volunteer applications to{" "}
              <span className="text-bdu-gold">{email}</span>
            </div>
            <div className="mt-1 italic font-serif text-bdu-gold text-lg">Let's have a ball organizing the Ball of the Century.</div>
          </div>
          <a
            href={mailto}
            className="btn-gold"
            data-testid={`event-organizer-inquire-${event.id}`}
          >
            <Mail size={14} /> Send Inquiry
          </a>
        </div>
      )}
    </div>
  );
}
